import type { ButtonHTMLAttributes, CSSProperties, ReactNode } from "react";

type Variant = "primary" | "secondary" | "ghost";
type Size = "sm" | "md" | "lg";

interface Props extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "size"> {
  variant?: Variant;
  size?: Size;
  full?: boolean;
  children: ReactNode;
}

const sizes: Record<Size, CSSProperties> = {
  sm: { padding: "8px 14px", fontSize: 13 },
  md: { padding: "10px 18px", fontSize: 14 },
  lg: { padding: "14px 22px", fontSize: 15 },
};

export function Btn({ variant = "primary", size = "md", full, children, style, ...rest }: Props) {
  const base: CSSProperties = {
    ...sizes[size],
    borderRadius: 12,
    fontWeight: 600,
    fontFamily: "var(--ui)",
    border: "1px solid transparent",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    width: full ? "100%" : undefined,
    cursor: "pointer",
    transition: "background .12s, border-color .12s, opacity .12s",
  };
  const variants: Record<Variant, CSSProperties> = {
    primary: { background: "var(--accent)", color: "var(--accent-ink)", borderColor: "var(--accent)" },
    secondary: { background: "var(--surface)", color: "var(--ink)", borderColor: "var(--line)" },
    ghost: { background: "transparent", color: "var(--ink-soft)", borderColor: "transparent" },
  };
  return (
    <button {...rest} style={{ ...base, ...variants[variant], ...style }}>
      {children}
    </button>
  );
}
